<template>
  <el-dialog
    v-if="isProcessRecordDialog"
    :title="$t('eip.flow.processingRecords')"
    :visible.sync="isProcessRecordDialog"
    :close-on-click-modal="false"
    class="process-record-dialog"
    append-to-body
    top="3vh"
    width="85%"
  >
    <process-record
      ref="processRecord"
      :inst-id="instId"
      :task-id="taskId"
      :refer-opinion="referOpinion"
      :node-type="nodeType"
      :def-id="defId"
      :node-id="nodeId"
    />

    <span slot="footer">
      <el-button
        type="primary"
        size="small"
        :style="{
          color: '#FFFFFF',
          background: '#0560FD',
        }"
        @click="refresh"
      >
        {{ $t('ht.tree.refresh') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
  /* eslint-disable */
  import ProcessRecord from '@/components/flow/processRecord.vue'
  export default {
    name: 'ProcessRecordDialog',
    components: { ProcessRecord },
    props: ['instId', 'taskId', 'referOpinion', 'nodeType', 'defId', 'nodeId'],
    data() {
      return {
        isProcessRecordDialog: false,
      }
    },
    methods: {
      handleOpen() {
        this.isProcessRecordDialog = true
      },
      refresh() {
        this.$refs?.processRecord?.loadData()
      },
    },
  }
</script>

<style lang="scss">
.process-record-dialog {
  .el-dialog__footer {
    padding: 20px 0;
    margin: 0 20px;
  }
}

</style>
